/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_TitleInputs */

const en_svc_ai_agent_development_title = /** @type {(inputs: Svc_Ai_Agent_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Agent Development`)
};

const ar_svc_ai_agent_development_title = /** @type {(inputs: Svc_Ai_Agent_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطوير وكلاء الذكاء الاصطناعي`)
};

const bn_svc_ai_agent_development_title = /** @type {(inputs: Svc_Ai_Agent_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI এজেন্ট ডেভেলপমেন্ট`)
};

const de_svc_ai_agent_development_title = /** @type {(inputs: Svc_Ai_Agent_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Agentenentwicklung`)
};

const es_svc_ai_agent_development_title = /** @type {(inputs: Svc_Ai_Agent_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollo de agentes de IA`)
};

const fr_svc_ai_agent_development_title = /** @type {(inputs: Svc_Ai_Agent_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développement d'agents IA`)
};

const pt_svc_ai_agent_development_title = /** @type {(inputs: Svc_Ai_Agent_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvimento de agente de IA`)
};

const zh_svc_ai_agent_development_title = /** @type {(inputs: Svc_Ai_Agent_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI代理开发`)
};

const tr_svc_ai_agent_development_title = /** @type {(inputs: Svc_Ai_Agent_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapay Zeka Aracısı Geliştirme`)
};

const ru_svc_ai_agent_development_title = /** @type {(inputs: Svc_Ai_Agent_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработка ИИ-агента`)
};

const pl_svc_ai_agent_development_title = /** @type {(inputs: Svc_Ai_Agent_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozwój agenta AI`)
};

/**
* | output |
* | --- |
* | "AI Agent Development" |
*
* @param {Svc_Ai_Agent_Development_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_title = /** @type {((inputs?: Svc_Ai_Agent_Development_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_title(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_title(inputs)
	if (locale === "de") return de_svc_ai_agent_development_title(inputs)
	if (locale === "es") return es_svc_ai_agent_development_title(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_title(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_title(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_title(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_title(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_title(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_title(inputs)
	return en_svc_ai_agent_development_title(inputs)
});
export { svc_ai_agent_development_title as "svc_ai-agent-development_title" }